import React from "react";
import NachPreVerification from "./NachPreVerification";
import NachVerification from "./NachVerification";
const Verification = () => {
  return (
    <>
      {/* <NachPreVerification /> */}
      <NachVerification />
    </>
  );
};

export default Verification;
